import { ModalManager } from '@shared/components/providers/ModalProvider';
import { getLabel } from '@shared/utils';
import { Box, Button, Checkbox, Divider, FormControlLabel, FormGroup } from '@mui/material';
import { getAllPermissions } from '@shared/services/api/permissionService';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const AssignPermissionsStep = ({ correspondentRole = {}, handleBack, handleSubmit, onComplete }) => {
  const editMode = correspondentRole?.role_id !== undefined;
  const [permissions, setPermissions] = useState([]);
  const [correspondentRoleData, setCorrespondentRoleData] = useState(correspondentRole || {});
  const [checked, setChecked] = useState(new Set(correspondentRoleData.permissions || []));
  useEffect(() => {
    const fetchData = async () => {
      let { data } = (await getAllPermissions()) || {};
      data = data?.data;
      setPermissions(data || []);
    };
    fetchData();
  }, []);

  const handleChange = (event) => {
    const newChecked = new Set(checked);
    if (newChecked.has(Number(event.target.name))) {
      newChecked.delete(Number(event.target.name));
    } else {
      newChecked.add(Number(event.target.name));
    }
    setChecked(newChecked);
    setCorrespondentRoleData({ ...correspondentRoleData, permissions: Array.from(newChecked) });
    onComplete({ ...correspondentRoleData, permissions: Array.from(newChecked) });
  };

  return (
    <>
      <form noValidate autoComplete="off">
        <FormGroup sx={{ maxHeight: '350px', overflow: 'auto', marginTop: '20px', border: '1px #7025c6 solid' }}>
          {permissions.map((permission) => (
            <FormControlLabel
              control={
                <Checkbox checked={checked.has(Number(permission.id))} onClick={handleChange} name={permission.id} />
              }
              label={permission.display_name}
              key={permission.id}
            />
          ))}
        </FormGroup>
      </form>
      <Divider orientation="horizontal" flexItem sx={{ backgroundColor: '#7025c6', marginTop: '24px' }} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <Button
          variant="outlined"
          sx={{ mt: 3, ml: 1 }}
          color="primary"
          onClick={() => {
            ModalManager.closeModal();
          }}>
          {getLabel('cancel')}
        </Button>
        <Button variant="outlined" sx={{ mt: 3, ml: 1 }} color="primary" onClick={handleBack}>
          {getLabel('back')}
        </Button>
        <Button variant="contained" sx={{ mt: 3, ml: 1 }} color="primary" onClick={handleSubmit}>
          {editMode ? getLabel('edit') : getLabel('add')}
        </Button>
      </Box>
    </>
  );
};

AssignPermissionsStep.propTypes = {
  correspondentRole: PropTypes.object,
  handleBack: PropTypes.func,
  handleSubmit: PropTypes.func,
  onComplete: PropTypes.func,
};

export default AssignPermissionsStep;
